import * as actionLoading from '../Loading/LoadingActions';
import * as actionToast from '../Toast/ToastActions';
import SystemDataService from '../../Services/SystemDataService';
import SystemDataConstants from './systemDataConsts';
import DataSourceConfig from '../../Config/DataSourceConfig';
import { getAllCategories } from '../../Public/category-data';

// === System Data Actions ===
export const updateSystemData = (data) => (dispatch) => {
    dispatch({
        type: SystemDataConstants.UPDATE_SYSTEM_DATA,
        payload: data,
    });
};

export const loadLinks = () => async (dispatch) => {
    try {
        dispatch(actionLoading.setLoading('Loading links...'));
        const links = await SystemDataService.getLinks();
        dispatch({ type: SystemDataConstants.SYSTEM_SET_LINKS, payload: links || [] });
    } catch (error) {
        console.error('Failed to load links', error);
        dispatch({ type: SystemDataConstants.SYSTEM_CLEAR_LINKS });
    } finally {
        dispatch(actionLoading.disableLoading());
    }
};

export const loadBannerMessages = () => async (dispatch) => {
    try {
        dispatch(actionLoading.setLoading('Loading banners...'));
        const banners = await SystemDataService.getBannerMessages();
        dispatch({ type: SystemDataConstants.SYSTEM_SET_BANNERS, payload: banners || [] });
    } catch (error) {
        console.error('Failed to load banner messages', error);
        dispatch({ type: SystemDataConstants.SYSTEM_CLEAR_BANNERS });
    } finally {
        dispatch(actionLoading.disableLoading());
    }
};

export const loadBusinessInfo = () => async (dispatch) => {
    try {
        dispatch(actionLoading.setLoading('Loading business info...'));
        const businessInfo = await SystemDataService.getBusinessInfo();
        dispatch({ type: SystemDataConstants.SYSTEM_SET_BUSINESS_INFO, payload: businessInfo || {} });
    } catch (error) {
        console.error('Failed to load business info', error);
        dispatch({ type: SystemDataConstants.SYSTEM_CLEAR_BUSINESS_INFO });
    } finally {
        dispatch(actionLoading.disableLoading());
    }
};

// === NEW: Media Registry / Gallery Actions ===

export const loadMediaRegistry = () => async (dispatch) => {
    try {
        dispatch(actionLoading.setLoading('Loading media gallery...'));
        // We will add getByPath('mediaRegistry') to your frontend SystemDataService next
        const registry = await SystemDataService.getByPath('mediaRegistry');
        dispatch({ type: SystemDataConstants.SYSTEM_SET_MEDIA_REGISTRY, payload: registry || [] });
    } catch (error) {
        console.error('Failed to load media registry', error);
        dispatch({ type: SystemDataConstants.SYSTEM_CLEAR_MEDIA_REGISTRY });
        dispatch(actionToast.setToast('error', 'Failed to load media gallery'));
    } finally {
        dispatch(actionLoading.disableLoading());
    }
};


export const loadCategories = () => async (dispatch) => {
    try {
        dispatch(actionLoading.setLoading('Loading active categories...'));

        let categories;
        if (DataSourceConfig.categories === 'local') {
            categories = getAllCategories();
        } else {
            categories = await SystemDataService.getCategories();
        }
        dispatch({ type: SystemDataConstants.SYSTEM_SET_CATEGORIES, payload: categories || [] });
    } catch (error) {
        console.error('Failed to load categories, falling back to local data', error);
        dispatch({ type: SystemDataConstants.SYSTEM_SET_CATEGORIES, payload: getAllCategories() });
    } finally {
        dispatch(actionLoading.disableLoading());
    }
};

// Note: This action returns the URL directly to the component so it can update its local draft state
export const uploadMediaFile = (file) => async (dispatch) => {
    try {
        dispatch(actionLoading.setLoading('Uploading media...'));
        // We will add uploadMedia() to your frontend SystemDataService next
        const uploadedUrl = await SystemDataService.uploadMedia(file);

        // Refresh the gallery in the background so the new image appears in the registry
        dispatch(loadMediaRegistry());
        dispatch(actionToast.setToast('success', 'Media uploaded successfully'));

        return uploadedUrl;
    } catch (error) {
        console.error('Failed to upload media', error);
        dispatch(actionToast.setToast('error', 'Failed to upload media file'));
        throw error;
    } finally {
        dispatch(actionLoading.disableLoading());
    }
};

// === Clear Helpers ===
export const clearLinks = () => (dispatch) => {
    dispatch({ type: SystemDataConstants.SYSTEM_CLEAR_LINKS });
};

export const clearBannerMessages = () => (dispatch) => {
    dispatch({ type: SystemDataConstants.SYSTEM_CLEAR_BANNERS });
};

export const clearBusinessInfo = () => (dispatch) => {
    dispatch({ type: SystemDataConstants.SYSTEM_CLEAR_BUSINESS_INFO });
};

export const clearMediaRegistry = () => (dispatch) => {
    dispatch({ type: SystemDataConstants.SYSTEM_CLEAR_MEDIA_REGISTRY });
};